import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PageState } from '~/shared/enums/stock-files.enum';

/**
 * @component SelectedAssetGridComponent
 * @description
 * Shared component for displaying and managing the currently selected asset
 * in transactional workflows (e.g. Perform Maintenance, Schedule Maintenance, etc.).
 * Displays Asset #, Asset Name, Site, Location, and provides an optional removal action.
 */
@Component({
    selector: 'asap-selected-asset-grid',
    templateUrl: './selected-asset-grid.component.html',
    styleUrls: ['./selected-asset-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectedAssetGridComponent implements OnInit {
  /** Array of selected asset records (typically single-item or collection) */
  @Input() data: any[] = [];

  /** Whether to show the section heading */
  @Input() showTitle: boolean = true;

  /** Title text for the section heading */
  @Input() title: string = 'Selected Asset';

  /** Explicit read-only mode flag */
  @Input() disabled: boolean = false;

  /** PageState enum to automatically determine read-only mode */
  @Input() pageState?: PageState;

  /** Emitted when the user clicks the Delete/Remove button on an asset */
  @Output() clearAsset = new EventEmitter<any>();

  /** Emitted when an asset row is clicked */
  @Output() assetClick = new EventEmitter<any>();

  get isReadOnly(): boolean {
    return this.disabled || this.pageState === PageState.VIEW;
  }

  constructor() {}

  ngOnInit(): void {}

  onClear(item?: any): void {
    if (this.isReadOnly) return;
    this.clearAsset.emit(item);
  }

  onRowClick(item: any): void {
    this.assetClick.emit(item);
  }
}
